import { useContext } from 'react';
import { ITableContext, TableContext } from './TableContext';

export function useTableContext<T>() {
  return useContext<ITableContext<T>>(TableContext);
}
